import moment from 'moment'

export function filtername (val) {
  return val && val.length > 20 ? val.slice(0, 20) + '...' : val
}

export function formatKm(val, digit) {
  var locale = 'tr';
  return parseFloat(val).toLocaleString(locale, {minimumFractionDigits: digit, maximumFractionDigits: digit});
}

export function setVehiclesPlates (vehicles, data) {
  const lastData = data.map((vehicle, index) => {
    const v = vehicles.find((item, index) => item.value === vehicle.vehicle_id)
    if (v) {
      vehicle.vehicle_id = v.label
    }
    return vehicle
  })
  return lastData
}

export function getGroupedData (data, countColumn, groupColumn = 'plate') {
  let last_data = []
  for (let i = 0; i < data.length; i++) {
    let is_avaliable = false
    for (let j = 0; j < last_data.length; j++) {
      if (last_data[j].groupColVal === data[i][groupColumn]) {
        is_avaliable = true
        last_data[j].children.push(data[i])
      }
    }

    if (!is_avaliable) {
      let row = {
        // mode: 'span',
        groupColumn: groupColumn,
        groupColVal: data[i][groupColumn],
        countColumn: countColumn,
        html: false,
        children: [data[i]]
      }
      last_data.push(row)
    }
  }
  return last_data
}

export function convertSecondsToTime (data, columns) {
  for (let i = 0; i < data.length; i++) {
    for (let j = 0; j < columns.length; j++) {
      const column = columns[j]
      if (data[i][column] || data[i][column] === 0) {
        data[i][column] = secondsToTime(data[i][column])
      }
    }
  }
  return data
}

export function secondsToTime (seconds) {
  if (seconds === 0 || seconds === '-' || seconds === null) {
    return '00:00:00'
  }
  return moment().startOf('day').seconds(seconds).format('HH:mm:ss')
}
